
import { Component, OnInit } from '@angular/core';
import { ProviderCategory } from './category';
import { Program } from '../Models/program.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgramService } from '../Services/program.service';
import { OrganizationService } from '../Services/organization.service';
import { ProviderCategoryService } from 'app/Services/provider-category.service';

@Component({
  selector: 'app-view-provider-category',
  templateUrl: './view-provider-category.component.html',
  styleUrls: ['./view-provider-category.component.css']
})
export class ViewProviderCategoryComponent implements OnInit {
  category: ProviderCategory;
  programs: Program[];
  id: string;

  constructor(
    private organizationAccessor: OrganizationService,
    private programAccessor: ProgramService,
    private providerCategoryAccessor: ProviderCategoryService,
    public router: Router,
    private route: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });
    this.category = await this.providerCategoryAccessor.findCategory(this.id);
    this.fetchProgramListData();
  }

  deleteProgramFromProvider(programId: string) {
    this.programAccessor.deleteProviderCategoryFromProgram(programId, this.id)
    this.router.navigate([`/home/viewProviderCategory/${this.id}`]);
  }

  fetchProgramListData() {
    this.programAccessor
      .getUpdatablePrograms()
      .snapshotChanges()
      .subscribe((programs) => {
        this.programs = [];
        programs.forEach((program) => {
          let p: Program = program.payload.val();
          p.key = program.key;
          this.programs.push(p);
        });
        this.programs = this.programs.filter(
          (program) => program.ProviderCategoryIds && program.ProviderCategoryIds.includes(this.id)
        );
        this.programs.forEach((program) => {
          this.organizationAccessor.getSingleOrganization(program.OrganizationId).then((org) => {
            if (org && program.Summary) {
                program.Summary = org.Name + ': ' + program.Summary;
            } else if (org) {
                program.Summary = org.Name;
            } else {
                program.Summary = 'No Name Found';
            }
          });
        })
        this.programs.sort(function (a, b) {
          return (a.Summary?.toUpperCase() || '').localeCompare(b.Summary?.toUpperCase() || '');
        });
      });
  }
}
